import { render, staticRenderFns } from "./LetterheadUploadDialog.vue?vue&type=template&id=19b97218&scoped=true"
import script from "./LetterheadUploadDialog.vue?vue&type=script&lang=js"
export * from "./LetterheadUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./LetterheadUploadDialog.vue?vue&type=style&index=0&id=19b97218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b97218",
  null
  
)

export default component.exports